import { handleActions } from 'redux-actions';
import { CAPS } from '@/constants';
const init = {
    data: {
        mors: [],
    },
};
export default handleActions({
    // @ts-expect-error: FIXME
    [CAPS.V2_PARTNERS_GET]: (state, { error, payload }) => {
        if (error) {
            return state;
        }
        return Object.assign(Object.assign({}, state), { partners: payload.data.mors || {} });
    },
}, init);
